/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  Hardpoint,
  Images,
  Model,
  ModelExtended,
  ModelHardpointsParams,
  ModelImagesParams,
  ModelLoanersParams,
  ModelModulePackages,
  ModelModulePackagesParams,
  ModelModules,
  ModelModulesParams,
  ModelPaint,
  ModelPosition,
  ModelUpgrade,
  ModelVariantsParams,
  ModelVideosParams,
  Models,
  ModelsEmbedParams,
  ModelsParams,
  ModelsUpdatedParams,
  ModelsWithDocksParams,
  SchemaValidationErrorResponse,
  StandardError,
  Videos
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Models List
 */
export const models = (
    params?: MaybeRefOrGetter<ModelsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<Models>(
      {url: `/models`, method: 'GET',
        params, signal
    },
      );
    }




export const getModelsQueryKey = (params?: MaybeRefOrGetter<ModelsParams>,) => {
    return [
    'models', ...(params ? [params] : [])
    ] as const;
    }


export const getModelsQueryOptions = <TData = Awaited<ReturnType<typeof models>>, TError = ErrorType<SchemaValidationErrorResponse>>(params?: MaybeRefOrGetter<ModelsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof models>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getModelsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof models>>> = ({ signal }) => models(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof models>>, TError, TData>
}

export type ModelsQueryResult = NonNullable<Awaited<ReturnType<typeof models>>>
export type ModelsQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary Models List
 */

export function useModels<TData = Awaited<ReturnType<typeof models>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params?: MaybeRefOrGetter<ModelsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof models>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getModelsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Embed Models
 */
export const modelsEmbed = (
    params: MaybeRefOrGetter<ModelsEmbedParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<Model[]>(
      {url: `/models/embed`, method: 'GET',
        params, signal
    },
      );
    }




export const getModelsEmbedQueryKey = (params?: MaybeRefOrGetter<ModelsEmbedParams>,) => {
    return [
    'models','embed', ...(params ? [params] : [])
    ] as const;
    }


export const getModelsEmbedQueryOptions = <TData = Awaited<ReturnType<typeof modelsEmbed>>, TError = ErrorType<SchemaValidationErrorResponse>>(params: MaybeRefOrGetter<ModelsEmbedParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelsEmbed>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getModelsEmbedQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof modelsEmbed>>> = ({ signal }) => modelsEmbed(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof modelsEmbed>>, TError, TData>
}

export type ModelsEmbedQueryResult = NonNullable<Awaited<ReturnType<typeof modelsEmbed>>>
export type ModelsEmbedQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary Embed Models
 */

export function useModelsEmbed<TData = Awaited<ReturnType<typeof modelsEmbed>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params: MaybeRefOrGetter<ModelsEmbedParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelsEmbed>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getModelsEmbedQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Latest Models
 */
export const modelsLatest = (

 signal?: AbortSignal
) => {


      return axiosClient<Model[]>(
      {url: `/models/latest`, method: 'GET', signal
    },
      );
    }




export const getModelsLatestQueryKey = () => {
    return [
    'models','latest'
    ] as const;
    }


export const getModelsLatestQueryOptions = <TData = Awaited<ReturnType<typeof modelsLatest>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelsLatest>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getModelsLatestQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof modelsLatest>>> = ({ signal }) => modelsLatest(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof modelsLatest>>, TError, TData>
}

export type ModelsLatestQueryResult = NonNullable<Awaited<ReturnType<typeof modelsLatest>>>
export type ModelsLatestQueryError = ErrorType<unknown>


/**
 * @summary Latest Models
 */

export function useModelsLatest<TData = Awaited<ReturnType<typeof modelsLatest>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelsLatest>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getModelsLatestQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Available Model-Slugs
 */
export const modelsSlugs = (

 signal?: AbortSignal
) => {


      return axiosClient<void>(
      {url: `/models/slugs`, method: 'GET', signal
    },
      );
    }




export const getModelsSlugsQueryKey = () => {
    return [
    'models','slugs'
    ] as const;
    }


export const getModelsSlugsQueryOptions = <TData = Awaited<ReturnType<typeof modelsSlugs>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelsSlugs>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getModelsSlugsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof modelsSlugs>>> = ({ signal }) => modelsSlugs(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof modelsSlugs>>, TError, TData>
}

export type ModelsSlugsQueryResult = NonNullable<Awaited<ReturnType<typeof modelsSlugs>>>
export type ModelsSlugsQueryError = ErrorType<unknown>


/**
 * @summary Available Model-Slugs
 */

export function useModelsSlugs<TData = Awaited<ReturnType<typeof modelsSlugs>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelsSlugs>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getModelsSlugsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Updated Models
 */
export const modelsUpdated = (
    params?: MaybeRefOrGetter<ModelsUpdatedParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<void>(
      {url: `/models/updated`, method: 'GET',
        params, signal
    },
      );
    }




export const getModelsUpdatedQueryKey = (params?: MaybeRefOrGetter<ModelsUpdatedParams>,) => {
    return [
    'models','updated', ...(params ? [params] : [])
    ] as const;
    }


export const getModelsUpdatedQueryOptions = <TData = Awaited<ReturnType<typeof modelsUpdated>>, TError = ErrorType<void | SchemaValidationErrorResponse>>(params?: MaybeRefOrGetter<ModelsUpdatedParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelsUpdated>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getModelsUpdatedQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof modelsUpdated>>> = ({ signal }) => modelsUpdated(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof modelsUpdated>>, TError, TData>
}

export type ModelsUpdatedQueryResult = NonNullable<Awaited<ReturnType<typeof modelsUpdated>>>
export type ModelsUpdatedQueryError = ErrorType<void | SchemaValidationErrorResponse>


/**
 * @summary Updated Models
 */

export function useModelsUpdated<TData = Awaited<ReturnType<typeof modelsUpdated>>, TError = ErrorType<void | SchemaValidationErrorResponse>>(
 params?: MaybeRefOrGetter<ModelsUpdatedParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelsUpdated>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getModelsUpdatedQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Models with Docks
 */
export const modelsWithDocks = (
    params?: MaybeRefOrGetter<ModelsWithDocksParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<Models>(
      {url: `/models/with-docks`, method: 'GET',
        params, signal
    },
      );
    }




export const getModelsWithDocksQueryKey = (params?: MaybeRefOrGetter<ModelsWithDocksParams>,) => {
    return [
    'models','with-docks', ...(params ? [params] : [])
    ] as const;
    }


export const getModelsWithDocksQueryOptions = <TData = Awaited<ReturnType<typeof modelsWithDocks>>, TError = ErrorType<SchemaValidationErrorResponse>>(params?: MaybeRefOrGetter<ModelsWithDocksParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelsWithDocks>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getModelsWithDocksQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof modelsWithDocks>>> = ({ signal }) => modelsWithDocks(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof modelsWithDocks>>, TError, TData>
}

export type ModelsWithDocksQueryResult = NonNullable<Awaited<ReturnType<typeof modelsWithDocks>>>
export type ModelsWithDocksQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary Models with Docks
 */

export function useModelsWithDocks<TData = Awaited<ReturnType<typeof modelsWithDocks>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params?: MaybeRefOrGetter<ModelsWithDocksParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelsWithDocks>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getModelsWithDocksQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Model Detail
 */
export const model = (
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      slug = toValue(slug);

      return axiosClient<ModelExtended>(
      {url: `/models/${slug}`, method: 'GET', signal
    },
      );
    }




export const getModelQueryKey = (slug: MaybeRefOrGetter<string>,) => {
    return [
    'models',slug
    ] as const;
    }


export const getModelQueryOptions = <TData = Awaited<ReturnType<typeof model>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof model>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getModelQueryKey(slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof model>>> = ({ signal }) => model(slug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(slug) !== null && toValue(slug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof model>>, TError, TData>
}

export type ModelQueryResult = NonNullable<Awaited<ReturnType<typeof model>>>
export type ModelQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Model Detail
 */

export function useModel<TData = Awaited<ReturnType<typeof model>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof model>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getModelQueryOptions(slug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @deprecated
 * @summary Model Fleetchart Image
 */
export const modelFleetchartImage = (
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      slug = toValue(slug);

      return axiosClient<unknown>(
      {url: `/models/${slug}/fleetchart-image`, method: 'GET', signal
    },
      );
    }




export const getModelFleetchartImageQueryKey = (slug: MaybeRefOrGetter<string>,) => {
    return [
    'models',slug,'fleetchart-image'
    ] as const;
    }


export const getModelFleetchartImageQueryOptions = <TData = Awaited<ReturnType<typeof modelFleetchartImage>>, TError = ErrorType<void | SchemaValidationErrorResponse | StandardError>>(slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelFleetchartImage>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getModelFleetchartImageQueryKey(slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof modelFleetchartImage>>> = ({ signal }) => modelFleetchartImage(slug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(slug) !== null && toValue(slug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof modelFleetchartImage>>, TError, TData>
}

export type ModelFleetchartImageQueryResult = NonNullable<Awaited<ReturnType<typeof modelFleetchartImage>>>
export type ModelFleetchartImageQueryError = ErrorType<void | SchemaValidationErrorResponse | StandardError>


/**
 * @deprecated
 * @summary Model Fleetchart Image
 */

export function useModelFleetchartImage<TData = Awaited<ReturnType<typeof modelFleetchartImage>>, TError = ErrorType<void | SchemaValidationErrorResponse | StandardError>>(
 slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelFleetchartImage>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getModelFleetchartImageQueryOptions(slug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Model Hardpoints
 */
export const modelHardpoints = (
    slug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ModelHardpointsParams>,
 signal?: AbortSignal
) => {
      slug = toValue(slug);
params = toValue(params);

      return axiosClient<Hardpoint[]>(
      {url: `/models/${slug}/hardpoints`, method: 'GET',
        params, signal
    },
      );
    }




export const getModelHardpointsQueryKey = (slug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ModelHardpointsParams>,) => {
    return [
    'models',slug,'hardpoints', ...(params ? [params] : [])
    ] as const;
    }


export const getModelHardpointsQueryOptions = <TData = Awaited<ReturnType<typeof modelHardpoints>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(slug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ModelHardpointsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelHardpoints>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getModelHardpointsQueryKey(slug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof modelHardpoints>>> = ({ signal }) => modelHardpoints(slug,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(slug) !== null && toValue(slug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof modelHardpoints>>, TError, TData>
}

export type ModelHardpointsQueryResult = NonNullable<Awaited<ReturnType<typeof modelHardpoints>>>
export type ModelHardpointsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Model Hardpoints
 */

export function useModelHardpoints<TData = Awaited<ReturnType<typeof modelHardpoints>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 slug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ModelHardpointsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelHardpoints>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getModelHardpointsQueryOptions(slug,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Model Images
 */
export const modelImages = (
    slug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ModelImagesParams>,
 signal?: AbortSignal
) => {
      slug = toValue(slug);
params = toValue(params);

      return axiosClient<Images>(
      {url: `/models/${slug}/images`, method: 'GET',
        params, signal
    },
      );
    }




export const getModelImagesQueryKey = (slug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ModelImagesParams>,) => {
    return [
    'models',slug,'images', ...(params ? [params] : [])
    ] as const;
    }


export const getModelImagesQueryOptions = <TData = Awaited<ReturnType<typeof modelImages>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(slug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ModelImagesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelImages>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getModelImagesQueryKey(slug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof modelImages>>> = ({ signal }) => modelImages(slug,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(slug) !== null && toValue(slug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof modelImages>>, TError, TData>
}

export type ModelImagesQueryResult = NonNullable<Awaited<ReturnType<typeof modelImages>>>
export type ModelImagesQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Model Images
 */

export function useModelImages<TData = Awaited<ReturnType<typeof modelImages>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 slug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ModelImagesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelImages>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getModelImagesQueryOptions(slug,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Model Loaners
 */
export const modelLoaners = (
    slug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ModelLoanersParams>,
 signal?: AbortSignal
) => {
      slug = toValue(slug);
params = toValue(params);

      return axiosClient<Models>(
      {url: `/models/${slug}/loaners`, method: 'GET',
        params, signal
    },
      );
    }




export const getModelLoanersQueryKey = (slug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ModelLoanersParams>,) => {
    return [
    'models',slug,'loaners', ...(params ? [params] : [])
    ] as const;
    }


export const getModelLoanersQueryOptions = <TData = Awaited<ReturnType<typeof modelLoaners>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(slug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ModelLoanersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelLoaners>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getModelLoanersQueryKey(slug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof modelLoaners>>> = ({ signal }) => modelLoaners(slug,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(slug) !== null && toValue(slug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof modelLoaners>>, TError, TData>
}

export type ModelLoanersQueryResult = NonNullable<Awaited<ReturnType<typeof modelLoaners>>>
export type ModelLoanersQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Model Loaners
 */

export function useModelLoaners<TData = Awaited<ReturnType<typeof modelLoaners>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 slug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ModelLoanersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelLoaners>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getModelLoanersQueryOptions(slug,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Model Module Packages
 */
export const modelModulePackages = (
    slug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ModelModulePackagesParams>,
 signal?: AbortSignal
) => {
      slug = toValue(slug);
params = toValue(params);

      return axiosClient<ModelModulePackages>(
      {url: `/models/${slug}/module-packages`, method: 'GET',
        params, signal
    },
      );
    }




export const getModelModulePackagesQueryKey = (slug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ModelModulePackagesParams>,) => {
    return [
    'models',slug,'module-packages', ...(params ? [params] : [])
    ] as const;
    }


export const getModelModulePackagesQueryOptions = <TData = Awaited<ReturnType<typeof modelModulePackages>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(slug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ModelModulePackagesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelModulePackages>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getModelModulePackagesQueryKey(slug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof modelModulePackages>>> = ({ signal }) => modelModulePackages(slug,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(slug) !== null && toValue(slug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof modelModulePackages>>, TError, TData>
}

export type ModelModulePackagesQueryResult = NonNullable<Awaited<ReturnType<typeof modelModulePackages>>>
export type ModelModulePackagesQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Model Module Packages
 */

export function useModelModulePackages<TData = Awaited<ReturnType<typeof modelModulePackages>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 slug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ModelModulePackagesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelModulePackages>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getModelModulePackagesQueryOptions(slug,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Model Modules
 */
export const modelModules = (
    slug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ModelModulesParams>,
 signal?: AbortSignal
) => {
      slug = toValue(slug);
params = toValue(params);

      return axiosClient<ModelModules>(
      {url: `/models/${slug}/modules`, method: 'GET',
        params, signal
    },
      );
    }




export const getModelModulesQueryKey = (slug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ModelModulesParams>,) => {
    return [
    'models',slug,'modules', ...(params ? [params] : [])
    ] as const;
    }


export const getModelModulesQueryOptions = <TData = Awaited<ReturnType<typeof modelModules>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(slug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ModelModulesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelModules>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getModelModulesQueryKey(slug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof modelModules>>> = ({ signal }) => modelModules(slug,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(slug) !== null && toValue(slug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof modelModules>>, TError, TData>
}

export type ModelModulesQueryResult = NonNullable<Awaited<ReturnType<typeof modelModules>>>
export type ModelModulesQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Model Modules
 */

export function useModelModules<TData = Awaited<ReturnType<typeof modelModules>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 slug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ModelModulesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelModules>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getModelModulesQueryOptions(slug,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Model Paints
 */
export const modelPaints = (
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      slug = toValue(slug);

      return axiosClient<ModelPaint[]>(
      {url: `/models/${slug}/paints`, method: 'GET', signal
    },
      );
    }




export const getModelPaintsQueryKey = (slug: MaybeRefOrGetter<string>,) => {
    return [
    'models',slug,'paints'
    ] as const;
    }


export const getModelPaintsQueryOptions = <TData = Awaited<ReturnType<typeof modelPaints>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelPaints>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getModelPaintsQueryKey(slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof modelPaints>>> = ({ signal }) => modelPaints(slug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(slug) !== null && toValue(slug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof modelPaints>>, TError, TData>
}

export type ModelPaintsQueryResult = NonNullable<Awaited<ReturnType<typeof modelPaints>>>
export type ModelPaintsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Model Paints
 */

export function useModelPaints<TData = Awaited<ReturnType<typeof modelPaints>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelPaints>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getModelPaintsQueryOptions(slug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Model Positions
 */
export const modelPositions = (
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      slug = toValue(slug);

      return axiosClient<ModelPosition[]>(
      {url: `/models/${slug}/positions`, method: 'GET', signal
    },
      );
    }




export const getModelPositionsQueryKey = (slug: MaybeRefOrGetter<string>,) => {
    return [
    'models',slug,'positions'
    ] as const;
    }


export const getModelPositionsQueryOptions = <TData = Awaited<ReturnType<typeof modelPositions>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelPositions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getModelPositionsQueryKey(slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof modelPositions>>> = ({ signal }) => modelPositions(slug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(slug) !== null && toValue(slug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof modelPositions>>, TError, TData>
}

export type ModelPositionsQueryResult = NonNullable<Awaited<ReturnType<typeof modelPositions>>>
export type ModelPositionsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Model Positions
 */

export function useModelPositions<TData = Awaited<ReturnType<typeof modelPositions>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelPositions>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getModelPositionsQueryOptions(slug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Model Snubcrafts
 */
export const modelSnubCrafts = (
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      slug = toValue(slug);

      return axiosClient<Model[]>(
      {url: `/models/${slug}/snub-crafts`, method: 'GET', signal
    },
      );
    }




export const getModelSnubCraftsQueryKey = (slug: MaybeRefOrGetter<string>,) => {
    return [
    'models',slug,'snub-crafts'
    ] as const;
    }


export const getModelSnubCraftsQueryOptions = <TData = Awaited<ReturnType<typeof modelSnubCrafts>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelSnubCrafts>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getModelSnubCraftsQueryKey(slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof modelSnubCrafts>>> = ({ signal }) => modelSnubCrafts(slug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(slug) !== null && toValue(slug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof modelSnubCrafts>>, TError, TData>
}

export type ModelSnubCraftsQueryResult = NonNullable<Awaited<ReturnType<typeof modelSnubCrafts>>>
export type ModelSnubCraftsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Model Snubcrafts
 */

export function useModelSnubCrafts<TData = Awaited<ReturnType<typeof modelSnubCrafts>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelSnubCrafts>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getModelSnubCraftsQueryOptions(slug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @deprecated
 * @summary Model Storeimage
 */
export const modelStoreImage = (
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      slug = toValue(slug);

      return axiosClient<unknown>(
      {url: `/models/${slug}/store-image`, method: 'GET', signal
    },
      );
    }




export const getModelStoreImageQueryKey = (slug: MaybeRefOrGetter<string>,) => {
    return [
    'models',slug,'store-image'
    ] as const;
    }


export const getModelStoreImageQueryOptions = <TData = Awaited<ReturnType<typeof modelStoreImage>>, TError = ErrorType<void | SchemaValidationErrorResponse>>(slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelStoreImage>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getModelStoreImageQueryKey(slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof modelStoreImage>>> = ({ signal }) => modelStoreImage(slug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(slug) !== null && toValue(slug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof modelStoreImage>>, TError, TData>
}

export type ModelStoreImageQueryResult = NonNullable<Awaited<ReturnType<typeof modelStoreImage>>>
export type ModelStoreImageQueryError = ErrorType<void | SchemaValidationErrorResponse>


/**
 * @deprecated
 * @summary Model Storeimage
 */

export function useModelStoreImage<TData = Awaited<ReturnType<typeof modelStoreImage>>, TError = ErrorType<void | SchemaValidationErrorResponse>>(
 slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelStoreImage>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getModelStoreImageQueryOptions(slug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Model Upgrades
 */
export const modelUpgrades = (
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      slug = toValue(slug);

      return axiosClient<ModelUpgrade[]>(
      {url: `/models/${slug}/upgrades`, method: 'GET', signal
    },
      );
    }




export const getModelUpgradesQueryKey = (slug: MaybeRefOrGetter<string>,) => {
    return [
    'models',slug,'upgrades'
    ] as const;
    }


export const getModelUpgradesQueryOptions = <TData = Awaited<ReturnType<typeof modelUpgrades>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelUpgrades>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getModelUpgradesQueryKey(slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof modelUpgrades>>> = ({ signal }) => modelUpgrades(slug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(slug) !== null && toValue(slug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof modelUpgrades>>, TError, TData>
}

export type ModelUpgradesQueryResult = NonNullable<Awaited<ReturnType<typeof modelUpgrades>>>
export type ModelUpgradesQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Model Upgrades
 */

export function useModelUpgrades<TData = Awaited<ReturnType<typeof modelUpgrades>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelUpgrades>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getModelUpgradesQueryOptions(slug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Model Variants
 */
export const modelVariants = (
    slug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ModelVariantsParams>,
 signal?: AbortSignal
) => {
      slug = toValue(slug);
params = toValue(params);

      return axiosClient<Models>(
      {url: `/models/${slug}/variants`, method: 'GET',
        params, signal
    },
      );
    }




export const getModelVariantsQueryKey = (slug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ModelVariantsParams>,) => {
    return [
    'models',slug,'variants', ...(params ? [params] : [])
    ] as const;
    }


export const getModelVariantsQueryOptions = <TData = Awaited<ReturnType<typeof modelVariants>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(slug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ModelVariantsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelVariants>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getModelVariantsQueryKey(slug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof modelVariants>>> = ({ signal }) => modelVariants(slug,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(slug) !== null && toValue(slug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof modelVariants>>, TError, TData>
}

export type ModelVariantsQueryResult = NonNullable<Awaited<ReturnType<typeof modelVariants>>>
export type ModelVariantsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Model Variants
 */

export function useModelVariants<TData = Awaited<ReturnType<typeof modelVariants>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 slug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ModelVariantsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelVariants>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getModelVariantsQueryOptions(slug,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Model Videos
 */
export const modelVideos = (
    slug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ModelVideosParams>,
 signal?: AbortSignal
) => {
      slug = toValue(slug);
params = toValue(params);

      return axiosClient<Videos>(
      {url: `/models/${slug}/videos`, method: 'GET',
        params, signal
    },
      );
    }




export const getModelVideosQueryKey = (slug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ModelVideosParams>,) => {
    return [
    'models',slug,'videos', ...(params ? [params] : [])
    ] as const;
    }


export const getModelVideosQueryOptions = <TData = Awaited<ReturnType<typeof modelVideos>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(slug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ModelVideosParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelVideos>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getModelVideosQueryKey(slug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof modelVideos>>> = ({ signal }) => modelVideos(slug,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(slug) !== null && toValue(slug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof modelVideos>>, TError, TData>
}

export type ModelVideosQueryResult = NonNullable<Awaited<ReturnType<typeof modelVideos>>>
export type ModelVideosQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Model Videos
 */

export function useModelVideos<TData = Awaited<ReturnType<typeof modelVideos>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 slug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ModelVideosParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelVideos>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getModelVideosQueryOptions(slug,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






